export default Object.freeze({
  branchID: undefined,
});
